import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "Pinter"
});
const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M14.4886 1.25C15.8066 1.25 16.875 2.29467 16.875 3.58333V17.5833C16.875 18.2277 16.3408 18.75 15.6818 18.75H4.94318C4.28421 18.75 3.75 18.2277 3.75 17.5833V3.58333C3.75 2.29467 4.81841 1.25 6.13636 1.25H14.4886ZM10.3125 15.8333C9.98301 15.8333 9.71591 16.0945 9.71591 16.4167C9.71591 16.7388 9.98301 17 10.3125 17C10.642 17 10.9091 16.7388 10.9091 16.4167C10.9091 16.0945 10.642 15.8333 10.3125 15.8333ZM13.2955 12.3333H7.32955V14.6667H13.2955V12.3333ZM15.0852 3H5.53977V10H15.0852V3Z",
  fill: "#42526E"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_3);
}
var pinter = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { pinter as default };
